<!-- For Admin or Default -->
<div *ngIf="(hasAdminRole() || (!hasAdminRole() && !hasParentRole())) && !hideLayout" id="main-wrapper">
    <app-header (displayChange)="onDisplayChange($event)"></app-header>
    <div class="sidebar-container">
        <div class="sidebar-row">
            <div class="left-side-sb hidden-sm-down">
                <app-sidebar></app-sidebar>
            </div>
            <div class="left-side-sb-mobile hidden-md-up animated easeout" *ngIf="isDisplayedInLayout">
                <app-sidebar></app-sidebar>
            </div>
            <div class="right-side-sb">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

<!-- For Parent -->
<div *ngIf="!hasAdminRole() && hasParentRole() && !hideLayout" id="main-parent-wrapper">
    <app-parent-header class="sticky-header" (displayChange)="onDisplayChange($event)"></app-parent-header>
    <div class="sidebar-parent-container">
        <div class="sidebar-parent-row">
            <div class="left-parent-side-sb">
                <app-parent-sidebar></app-parent-sidebar>
            </div>
            <div class="right-parent-side-sb">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

<div *ngIf="hideLayout" class="print-outlet">
    <router-outlet></router-outlet>
</div>